import { createSelector } from 'reselect';
import { ARTICLES_TYPE } from 'snippets/latesArticles';

const META_DEFAULT = {};
const CONTENT_DEFAULT = [];
const AUTHOR_DEFAULT = {};
const ARTICLES_DEFAULT = {};
const PROMO_DEFAULT = {};

// Селлектор на страницу по slug
const authorSelector = (state, slug) => state.author.pages[slug] || {};

/** Получение объекта meta из страницы автора */
export const metaAuthorSelector = createSelector(
  authorSelector,
  author => author.meta || META_DEFAULT,
);

/** Получение списка компонентов страницы автора */
export const contentAuthorSelector = createSelector(
  authorSelector,
  author => author.content || CONTENT_DEFAULT,
);

/** Получение информации о авторе */
export const infoAuthorSelector = createSelector(
  authorSelector,
  author => author.author || AUTHOR_DEFAULT,
);

/** Получение дополнительных данных компонента */
export const dataAuthorSelector = createSelector(
  authorSelector,
  author => author[ARTICLES_TYPE] || ARTICLES_DEFAULT,
);

/** Получение баннеров страницы */
export const promosAuthorSelector = createSelector(
  authorSelector,
  category => category.promo || PROMO_DEFAULT,
);
